import { ONBOARDING_STEPS } from '../../onboarding/onboardingSteps';

type Props = {
  completedSteps: string[];
};

const OnboardingProgress = ({ completedSteps }: Props) => {
  const total = ONBOARDING_STEPS.length;
  const done = completedSteps.filter((s) =>
    (ONBOARDING_STEPS as readonly string[]).includes(s),
  ).length;
  const pct = Math.round((done / total) * 100);

  return (
    <div className="mb-4">
      <div className="mb-1.5 flex justify-between text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        <span>Progress</span>
        <span>
          {done} of {total} steps
        </span>
      </div>
      <div className="h-1.5 overflow-hidden rounded-full bg-[color:var(--nq-surface-raised)]">
        <div
          className="h-full rounded-full bg-[linear-gradient(90deg,var(--nq-blue-deep,#1a2d4a),var(--nq-gold))] transition-[width] duration-[250ms] ease-out"
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuenow={done}
          aria-valuemin={0}
          aria-valuemax={total}
        />
      </div>
    </div>
  );
};

export default OnboardingProgress;
